import log from './track/log'
import copy from './operate/copy'
import hasPermi from './permission/hasPermi'

const install = function (Vue) {
  Vue.directive('log', log)
  Vue.directive('copy', copy)
  Vue.directive('hasPermi', hasPermi)
}

if (window.Vue) {
  window['copy'] = copy
  window['hasPermi'] = hasPermi
  Vue.use(install); // eslint-disable-line
}

export default install



// WEBPACK FOOTER //
// ./src/directive/index.js